'use client';

import { useState, useRef } from 'react';
import ContactHero from './ContactHero';
import ContactOptions from './ContactOptions';
import ContactForm from './ContactForm';
import OfficeLocations from './OfficeLocations';
import FAQSection from './FAQSection';

export default function ContactInteractive() {
  const [selectedOption, setSelectedOption] = useState<string>('');
  const formRef = useRef<HTMLDivElement>(null);

  const handleScrollToForm = () => {
    formRef.current?.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  const handleSelectOption = (optionId: string) => {
    setSelectedOption(optionId);
    handleScrollToForm();
  };

  return (
    <>
      <ContactHero data-component-id="src/app/contact/components/ContactInteractive.tsx:25:6" data-component-path="src/app/contact/components/ContactInteractive.tsx" data-component-line="25" data-component-file="ContactInteractive.tsx" data-component-name="ContactHero" data-component-content="%7B%22elementName%22%3A%22ContactHero%22%7D" onScrollToForm={handleScrollToForm} />
      <ContactOptions data-component-id="src/app/contact/components/ContactInteractive.tsx:26:6" data-component-path="src/app/contact/components/ContactInteractive.tsx" data-component-line="26" data-component-file="ContactInteractive.tsx" data-component-name="ContactOptions" data-component-content="%7B%22elementName%22%3A%22ContactOptions%22%7D" onSelectOption={handleSelectOption} />
      <div data-component-id="src/app/contact/components/ContactInteractive.tsx:27:6" data-component-path="src/app/contact/components/ContactInteractive.tsx" data-component-line="27" data-component-file="ContactInteractive.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%7D" ref={formRef}>
        <ContactForm data-component-id="src/app/contact/components/ContactInteractive.tsx:28:8" data-component-path="src/app/contact/components/ContactInteractive.tsx" data-component-line="28" data-component-file="ContactInteractive.tsx" data-component-name="ContactForm" data-component-content="%7B%22elementName%22%3A%22ContactForm%22%7D" selectedOption={selectedOption} />
      </div>
      {/* <OfficeLocations /> */}
      <FAQSection data-component-id="src/app/contact/components/ContactInteractive.tsx:31:6" data-component-path="src/app/contact/components/ContactInteractive.tsx" data-component-line="31" data-component-file="ContactInteractive.tsx" data-component-name="FAQSection" data-component-content="%7B%22elementName%22%3A%22FAQSection%22%7D" />
    </>
  );
}